import { useDispatch } from "react-redux";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import styles from "./Manual.module.scss";

const id = "dNT4";
const idNext = "dNT5";
const idPrev = "dNT3";

const next = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
        choices:
          - choice: AllGames
          - choice: AllLottery
          - choice: AllSports
          - choice: Lotto
          - choice: Vikinglotto
          - choice: Eurojackpot
          - choice: Extra
          - choice: Joker
          - choice: Keno
          - choice: Nabolaget
          - choice: Tipping
          - choice: Oddsbomben
      - parameter: Pause_Options
        choices:
          - choice: SpillePause
          - choice: Utestegning
`;

const prev = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
`;

function ManualDedicatedNorskTipping4({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      <div className={`${styles["foreground"]} ${styles["foreground-dnt4"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              As you can see, now that we’ve populated the parameter with choices, it is no longer
              marked with the red error mark. Let’s add a few more choices and repeat the process
              for one more parameter. Here are the choices I’d like you to add. However, If you
              don't want to do everything manually, feel free to click on the <b>Show me</b> button.
            </p>
            <table>
              <tr>
                <th>Exclusion_Service</th>
                <th>Pause_Option</th>
              </tr>
              <tr>
                <td>AllGames</td>
                <td>SpillePause</td>
              </tr>
              <tr>
                <td>AllLottery</td>
                <td>Utestegnig</td>
              </tr>
              <tr>
                <td>AllSports</td>
                <td></td>
              </tr>
              <tr>
                <td>Lotto</td>
                <td></td>
              </tr>
              <tr>
                <td>Vikinglotto</td>
                <td></td>
              </tr>
              <tr>
                <td>Eurojackpot</td>
                <td></td>
              </tr>
              <tr>
                <td>Extra</td>
                <td></td>
              </tr>
              <tr>
                <td>Joker</td>
                <td></td>
              </tr>
              <tr>
                <td>Keno</td>
                <td></td>
              </tr>
              <tr>
                <td>Nabolaget</td>
                <td></td>
              </tr>
              <tr>
                <td>Tippint</td>
                <td></td>
              </tr>
              <tr>
                <td>Oddsbomben</td>
                <td></td>
              </tr>
            </table>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateDedicatedNorskTipping4 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root, "Demo");

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resA, msg: msgA } = tutorialUtils.validateChoices(
      root,
      "root→[function]→Demo→[parameter]→Exclusion_Service",
      [
        "AllGames",
        "AllLottery",
        "AllSports",
        "Lotto",
        "Vikinglotto",
        "Eurojackpot",
        "Extra",
        "Joker",
        "Keno",
        "Nabolaget",
        "Tipping",
        "Oddsbomben",
      ],
    );

    if (!resA) {
      setMessage(msgA);
      return false;
    }

    let { res: resB, msg: msgB } = tutorialUtils.validateChoices(
      root,
      "root→[function]→Demo→[parameter]→Pause_Options",
      ["SpillePause", "Utestegning"],
    );

    if (!resB) {
      setMessage(msgB);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualDedicatedNorskTipping4;
